<template>
  <div>
    <Suspense><slot class="font-sans" /></Suspense>
    <LoadingIndicator />
  </div>
</template>

<script lang="ts" setup>
import LoadingIndicator from '@repo/ui/components/LoadingIndicator.vue';
</script>

<style>
/* see https://stackoverflow.com/questions/55206901/how-to-import-css-files-in-vue-3-child-components */
@import "./tailwind.css";
@import "./styles.css";

body {
  margin: 0;
}
* {
  box-sizing: border-box;
}
a {
  text-decoration: none;
}
</style>
